import React from 'react';
import { useNavigate } from 'react-router';
import BadgeIcon from 'components/BadgeIcon/BadgeIcon';
import FeatureCardLayout from './FeatureCardLayout';
import './TrophyCaseCard.css';

interface TrophyCaseCardProps {
  isElite: boolean;
  username?: string;
}

const SAMPLE_BADGES = [
  { icon: 'crown', shape: 'shield' as const, tier: 'gold' as const },
  { icon: 'star', shape: 'circle' as const, tier: 'silver' as const },
  { icon: 'gem', shape: 'hex' as const, tier: 'diamond' as const },
  { icon: 'fire', shape: 'shield' as const, tier: 'mythic' as const },
];

const TrophyCaseCard: React.FC<TrophyCaseCardProps> = ({ isElite, username }) => {
  const navigate = useNavigate();

  const preview = (
    <div className="trophy-card-preview">
      <div className="trophy-card-comparison">
        <div className="trophy-card-tier">
          <span className="trophy-card-tier-label">Free</span>
          <div className="trophy-card-badges">
            <BadgeIcon icon="trophy" shape="shield" tier="bronze" size={32} />
            <div className="trophy-card-empty-slot" />
            <div className="trophy-card-empty-slot" />
            <div className="trophy-card-empty-slot" />
          </div>
        </div>

        <div className="trophy-card-arrow">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M5 12h14m-4-4l4 4-4 4" stroke="#DD5BEA" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>

        <div className="trophy-card-tier">
          <span className="trophy-card-tier-label trophy-card-tier-label--elite">Elite</span>
          <div className="trophy-card-badges">
            {SAMPLE_BADGES.map((badge, i) => (
              <BadgeIcon
                key={i}
                icon={badge.icon}
                shape={badge.shape}
                tier={badge.tier}
                size={32}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  const cta = isElite ? (
    <button
      className="feature-card-btn feature-card-btn--outline"
      onClick={() => navigate(`/profile/u/${username}?tab=trophy-case`)}
    >
      Manage Trophy Case
    </button>
  ) : (
    <p className="feature-card-aspirational">
      Showcase up to 4 of your favorite badges
    </p>
  );

  return (
    <FeatureCardLayout
      title="Expanded Trophy Case"
      description="Showcase up to 4 achievement badges on your profile that represent you best."
      previewContent={preview}
      ctaContent={cta}
      className="trophy-card"
    />
  );
};

export default TrophyCaseCard;
